'use client'

import React from 'react'
import { cn } from '@/utilities/ui'

interface KeyPoint {
  title: string
  subtitle: string
  text: string
}

interface KeyPointsContentProps {
  keyPoints: KeyPoint[]
  className?: string
}

export const KeyPointsContent: React.FC<KeyPointsContentProps> = ({
  keyPoints,
  className,
}) => {
  return (
    <div className={cn('flex flex-col gap-6', className)}>
      {keyPoints.map((point, index) => (
        <section
          key={index}
          className="group border-t border-civo-cloud pt-6 pr-6 min-w-60"
        >
          <div className="flex flex-col gap-5 lg:gap-9 pl-0 group-hover:pl-6 group-hover:border-l group-hover:border-black transition-all duration-300">
            {/* Title */}
            <p className="display-small">
              {point.title}
            </p>

            {/* Content block */}
            <div className="flex flex-col gap-4">
              {/* Subtitle */}
              {point.subtitle && (
                <p className="subheading-medium">
                  {point.subtitle}
                </p>
              )}

              {/* Text */}
              <p className="body-large text-black/70">
                {point.text}
              </p>
            </div>
          </div>
        </section>
      ))}
    </div>
  )
}
